import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-programation',
  templateUrl: './programation.component.html',
  styleUrls: ['./programation.component.scss']
})
export class ProgramationComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
